/* eslint-disable no-useless-catch */

import {
  ListNotificationsByPersonByReadQuery, Notification, ReadState,
} from 'API';
import { listNotificationsByPersonByRead } from 'graphql/queries';
import { client } from 'lib/graphql-client';
import { GraphQLResult } from '@aws-amplify/api';
import { post } from 'aws-amplify/api';
import { fetchAuthSession } from 'aws-amplify/auth';

class NotificationService {
  getUnreadCount = async (personID: string):Promise<number> => {
    try {
      const response = (await client.graphql({
        query: listNotificationsByPersonByRead,
        variables: {
          personID,
          readCreatedAt: { beginsWith: { read: ReadState.UNREAD } },
          limit: 50,
        },
      })) as GraphQLResult<ListNotificationsByPersonByReadQuery>;

      const { data } = response;

      if (data?.listNotificationsByPersonByRead?.items) {
        return data.listNotificationsByPersonByRead.items.length;
      }

      throw new Error();
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
      throw new Error();
    }
  };

  markReadAll = async (personID: string) => {
    const cogToken = (await fetchAuthSession()).tokens?.idToken?.toString() ?? '';
    const payload = {
      body: {
        personID,
      },
      headers: {
        'Content-Type': 'application/json',
        Authorization: cogToken,
      },
    };

    const { body: allBody } = await post({ apiName: 'utilitiesapi', path: '/notifications/markReadAll', options: payload as any }).response;

    return allBody.json() as unknown as { updatedCount: number };
  };

  markRead = async (notifications: Array<Notification>, personID: string) => {
    const cogToken = (await fetchAuthSession()).tokens?.idToken?.toString() ?? '';
    const payload = {
      body: {
        personID,
        notifications: notifications.map((notification) => ({
          id: notification.id,
          createdAt: notification.createdAt,
        })),
      },
      headers: {
        'Content-Type': 'application/json',
        Authorization: cogToken,
      },
    };

    const { body: readBody } = await post({ apiName: 'utilitiesapi', path: '/notifications/markRead', options: payload as any }).response;

    return readBody.json() as unknown as { updatedCount: number };
  };
}

export default new NotificationService();
